/* Chahal WhatsApp support widget */
(function () {
  function init() {
    var root = document.getElementById('caf-wa');
    if (!root) return;
    var bubble = document.getElementById('caf-wa-bubble');
    var card = document.getElementById('caf-wa-card');
    var closeBtn = document.getElementById('caf-wa-close');
    var cta = document.getElementById('caf-wa-cta');
    var msg = document.getElementById('caf-wa-msg');
    if (!bubble || !card || !cta) return;

    // Time-aware greeting prefix
    var h = new Date().getHours();
    var greeting = h < 12 ? 'Good morning!' : (h < 17 ? 'Good afternoon!' : 'Good evening!');
    if (msg) { msg.textContent = greeting + ' ' + msg.textContent; }

    // Build wa.me link
    var number = root.getAttribute('data-number') || '';
    var prefill = root.getAttribute('data-prefill') || '';
    cta.setAttribute('href', 'https://wa.me/' + number + (prefill ? ('?text=' + prefill) : ''));

    function open() {
      card.hidden = false;
      // allow layout before transition
      requestAnimationFrame(function () { root.classList.add('is-open'); });
      bubble.setAttribute('aria-expanded', 'true');
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      root.classList.remove('is-open');
      bubble.setAttribute('aria-expanded', 'false');
      card.hidden = true;
      bubble.focus();
    }
    function toggle() { (card.hidden ? open : close)(); }

    bubble.addEventListener('click', toggle);
    if (closeBtn) closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !card.hidden) close();
    });
    document.addEventListener('click', function (e) {
      if (!card.hidden && !root.contains(e.target)) close();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
